module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    attrs: {
      "id": "the-overflow"
    }
  }, [_c('router-link', {
    staticClass: "button-type-f",
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Go back to products")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "border": "1px solid #efefef"
    },
    attrs: {
      "src": 'static/images/products/' + _vm.product_info.code + '.jpg',
      "alt": _vm.product_info.name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product-data"
  }, [_c('h2', [_vm._v(_vm._s(_vm.product_info.name))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Category")]), _vm._v(" " + _vm._s(_vm.product_info.category))]), _vm._v(" "), (!_vm.disabled) ? _c('p', [_c('strong', [_vm._v("Price")]), _vm._v(" Php " + _vm._s(_vm.formatMoney(_vm.product_info.price)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product-data"
  }, [_c('h2', [_vm._v("Product Specs")]), _vm._v(" "), _c('ul', {
    staticClass: "product-specs"
  }, [_c('li', [_c('strong', [_vm._v("Materials")]), _vm._v(" " + _vm._s(_vm.product_info.materials))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Socket Type")]), _vm._v(" " + _vm._s(_vm.product_info.socket))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Best For:")]), _vm._v(" " + _vm._s(_vm.product_info.forplace))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("No. of Bulbs:")]), _vm._v(" " + _vm._s(_vm.product_info.numbulb))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.product_info.led))])])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-939fa2a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product.vue
// module id = 161
// module chunks = 0